import { Timestamp } from '@griply/types';

export const getCalendarEventDate = (
  date: Timestamp | null | undefined,
  allDay: boolean,
): string | undefined => {
  if (!date) {
    return undefined;
  }

  if (!allDay) {
    return date.toISOString();
  }

  // FullCalendar represents all-day events at UTC midnight; reading the instant
  // back in a behind-UTC zone lands on the previous local day. Rebuild the same
  // calendar day as a local date so downstream day/week logic uses the right day.
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
  ).toISOString();
};
